import { Coins } from '@phosphor-icons/react';

export default Coins;
